module.exports = {
  annotate: require(65).annotate,
  Module: require(68),
  Injector: require(67)
};
